import { Controller } from "@hotwired/stimulus"

const STORAGE_KEY = "contents_accordion_state"
const RESTORE_DELAY_MS = 500

// Connects to the data-controller="content-accordion"
export default class extends Controller {
  static targets = ["button", "panel"]

  connect() {
    this.boundRestorePanels = this.restorePanels.bind(this)
    document.addEventListener("content-accordion:open", this.boundRestorePanels)

    if (this.hasButtonTarget) {
      this.restorePanels()
    }
  }

  disconnect() {
    document.removeEventListener("content-accordion:open", this.boundRestorePanels)
    clearTimeout(this.timeout)
  }

  toggle(event) {
    event.preventDefault()

    const button = event.currentTarget
    const panel = this.panelTargets[button.dataset.index]
    const shouldBeOpen = !this.isPanelOpen(panel)

    this.setPanelState(panel, button, shouldBeOpen)
    this.persistState()
  }

  restorePanels() {
    clearTimeout(this.timeout)

    this.timeout = setTimeout(() => {
      const storedState = this.getStoredState()

      this.buttonTargets.forEach((button, index) => {
        const panel = this.panelTargets[index]
        const shouldBeOpen = storedState[button.dataset.key] !== false
        this.setPanelState(panel, button, shouldBeOpen)
      })
    }, RESTORE_DELAY_MS)
  }

  setPanelState(panel, button, shouldBeOpen) {
    const icon = button.querySelector("[data-icon]")
    icon?.classList.toggle("rotate-90", shouldBeOpen)

    panel.style.maxHeight = shouldBeOpen ? `${panel.scrollHeight}px` : null
    panel.style.marginTop = shouldBeOpen ? "20px" : null
  }

  isPanelOpen(panel) {
    return Boolean(panel.style.maxHeight)
  }

  persistState() {
    const state = {}
    this.buttonTargets.forEach((button, index) => {
      const panel = this.panelTargets[index]
      state[button.dataset.key] = this.isPanelOpen(panel)
    })

    try {
      sessionStorage.setItem(STORAGE_KEY, JSON.stringify(state))
    } catch {
    }
  }

  getStoredState() {
    try {
      return JSON.parse(sessionStorage.getItem(STORAGE_KEY)) || {}
    } catch {
      return {}
    }
  }
}
